import React from 'react'

import { rhythm } from '../utils/typography'

class Bio extends React.Component {
  render() {
    return (
      <div
        style={{
          display: 'flex',
          marginBottom: rhythm(2.5),
        }}
      >
        <p>
          Find Better Questions is a tool to help find better questions on Quora.{' '}
          <a target="blank" href="https://findbetterquestions.com">
            Sign up here.
          </a>
        </p>
      </div>
    )
  }
}

export default Bio
